import { useQuery } from '@tanstack/react-query';
import { publicApi } from '@/services/api';
import type { ConsentContent } from '@/modules/consent/types';

export function useConsentContent() {
    return useQuery({
        queryKey: ['consent', 'content'],
        queryFn: async () => {
            const { data } = await publicApi.get<{ success: boolean; data: ConsentContent }>('/consent-settings');
            return data.data;
        },
        staleTime: 5 * 60 * 1000,
    });
}
